import axiosInstance from "../axiosInstance"
import type {
  MotoGearResponseDto,
  CreateMotoGearDto,
  UpdateMotoGearDto,
  MotoGearListParams,
  MotoGearListResponseDto,
  DeleteMotoGearResponseDto,
} from "../types/motoGear.types"

/**
 * Moto Gear API Client
 * Direct API calls using axios instance
 */
export const motoGearClient = {
  // Get moto gear by ID
  getMotoGearById: (id: string): Promise<MotoGearResponseDto> => {
    return axiosInstance.get(`/moto-gears/${id}`)
  },

  // List moto gears with filters
  getMotoGears: (params?: MotoGearListParams): Promise<MotoGearListResponseDto> => {
    return axiosInstance.get("/moto-gears", { params })
  },

  // Create moto gear (Admin only)
  createMotoGear: (data: CreateMotoGearDto): Promise<MotoGearResponseDto> => {
    return axiosInstance.post("/moto-gears", data)
  },

  // Update moto gear (Admin only)
  updateMotoGear: (id: string, data: UpdateMotoGearDto): Promise<MotoGearResponseDto> => {
    return axiosInstance.put(`/moto-gears/${id}`, data)
  },

  // Delete moto gear (Admin only)
  deleteMotoGear: (id: string): Promise<DeleteMotoGearResponseDto> => {
    return axiosInstance.delete(`/moto-gears/${id}`)
  },
}
